import React from "react"
import clsx from "clsx"
//import I18n from "i18n-js/index.js.erb"
import DataTable from "../../DataTable/DataTable"

class PropertyDetailsBuilderRuQueueLogs extends React.Component {

  constructor(props) {
    super(props);
  };

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'ru_queue_logs',
      'tab-pane': true,
    });
    return (
      <div className={tabClasses}>
        <DataTable
            endpoint={this.props.ru_queue_logs_data_table_path ? this.props.ru_queue_logs_data_table_path : null}
            // newRecord={this.props.new_record}
            no_data_text={I18n.t('none')}
            currency_unit={I18n.t('number.currency.format.unit')}
            delimiter={I18n.t('number.currency.format.delimiter')}
            separator={I18n.t('number.currency.format.separator')}
            date_format={this.props.date_format}
            time_format={this.props.time_format} />
      </div>
    );
  };

}

export default PropertyDetailsBuilderRuQueueLogs
